// Port of api/fuel/app/classes/filter/search/games/sorts/post/play/plays/count.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { sorted, sortReverse } from 'offline/filter/core/search/unit'

function getActiveName(filter) {
	if (sorted('plays', filter) > 0) return 'plays'
	if (sorted('plays.all', filter) > 0) return 'plays.all'
	if (sorted('plays.context', filter) > 0) return 'plays.context'
	return null
}

function hasPlayedContext(filter) {
	if (!filter.played) return false

	return !!(
		(filter.played.range && (filter.played.range.from || filter.played.range.to)) ||
		(filter.played.sometime && (filter.played.sometime.from || filter.played.sometime.to)) ||
		(filter.played.never && (filter.played.never.from || filter.played.never.to)) ||
		(filter.played.first && (filter.played.first.from || filter.played.first.to)) ||
		(filter.played.last && (filter.played.last.from || filter.played.last.to)) ||
		(filter.played.context && (filter.played.context.from || filter.played.context.to))
	)
}

function buildDateRange(name, filter) {
	var clauses = []
	if (name !== 'plays.context' || !filter.played) return clauses

	if (filter.played.range && (filter.played.range.from || filter.played.range.to)) {
		if (filter.played.range.from) clauses.push('play_date >= ' + filter.played.range.from)
		if (filter.played.range.to) clauses.push('play_date <= ' + filter.played.range.to)
		return clauses
	}

	if (filter.played.context && (filter.played.context.from || filter.played.context.to)) {
		if (filter.played.context.from) clauses.push('play_date >= ' + filter.played.context.from)
		if (filter.played.context.to) clauses.push('play_date <= ' + filter.played.context.to)
	}

	return clauses
}

export default {
	name: 'post.sort.play.plays.count',
	post: true,
	sorts: function(config, filter) {
		if (config.resultType === F.RESULT_PLAY || config.resultType === F.RESULT_RATING) {
			return ['plays', 'plays.all', 'plays.context']
		}
		if ((config.resultType === F.RESULT_GAME || config.resultType === F.RESULT_COLLECTION) && hasPlayedContext(filter)) {
			return ['plays.all', 'plays.context']
		}
		return []
	},
	modifies: function(config) {
		return config.resultType === F.RESULT_GAME ? 'index' : 'games'
	},
	require: function(config, filter) {
		var name = getActiveName(filter)
		if (!name) return false

		return config.resultType === F.RESULT_PLAY || config.resultType === F.RESULT_RATING ||
			((config.resultType === F.RESULT_GAME || config.resultType === F.RESULT_COLLECTION) && hasPlayedContext(filter))
	},
	run: function(config, filter, data, results) {
		if (!results.games || !results.games.length) return results

		var name = getActiveName(filter)
		var sql = 'SELECT game_id, SUM(play_count) as cnt FROM play WHERE game_id IN(' + Util.in(results.games) + ') AND user_id IN(' + Util.in(data.users) + ')'

		var dateRange = buildDateRange(name, filter)
		for (var i = 0; i < dateRange.length; i++) {
			sql += ' AND ' + dateRange[i]
		}

		sql += ' GROUP BY game_id'
		var rows = DB.query(sql)
		var counts = Util.associated(rows, 'game_id', 'cnt')
		var reverse = sortReverse(name, filter)

		// Get game names for tiebreaker (PHP uses g.game_name ASC)
		var playedGameIds = Util.pluck(rows, 'game_id')
		var nameRows = playedGameIds.length
			? DB.query('SELECT game_id, game_name FROM game WHERE game_id IN(' + Util.in(playedGameIds) + ')')
			: []
		var names = Util.associated(nameRows, 'game_id', 'game_name')

		// PHP replaces the game list with only games that have plays (INNER JOIN on play table),
		// so games with 0 plays are removed. We replicate by filtering to games in the query result.
		results.games = playedGameIds.slice().sort(function(a, b) {
			var ca = parseInt(counts[a] || 0), cb = parseInt(counts[b] || 0)
			var diff = reverse ? cb - ca : ca - cb
			if (diff !== 0) return diff
			var na = (names[a] || '').toLowerCase(), nb = (names[b] || '').toLowerCase()
			return na < nb ? -1 : na > nb ? 1 : 0
		})

		var gameOrder = {}
		for (var j = 0; j < results.games.length; j++) gameOrder[results.games[j]] = j

		// Filter index to only include items whose game is in the played set
		var playedSet = {}
		for (var k = 0; k < playedGameIds.length; k++) playedSet[playedGameIds[k]] = true
		results.index = results.index.filter(function(id) {
			var gid = results.mapIndex ? results.mapIndex[id] : id
			return !!playedSet[gid]
		})

		results.index.sort(function(a, b) {
			var ga = results.mapIndex ? results.mapIndex[a] : a
			var gb = results.mapIndex ? results.mapIndex[b] : b
			return (gameOrder[ga] || 0) - (gameOrder[gb] || 0)
		})

		return results
	}
}
